__turbopack_context__.v({
  "promo": "Promo-module__L6dd4W__promo",
  "promoBg": "Promo-module__L6dd4W__promoBg",
  "promoHeader": "Promo-module__L6dd4W__promoHeader",
});
